
import './PreviewModalInfo.scss';
export default function PreviewModalInfo(props: any) {
    return (
        <div className="previewModal--info " style={{ opacity: 1 }}>{props.children}</div>
    );
}